/**
 * Created by xinqiao on 2020/9
 */
/**
 * @description版本迭代code
 * @param {string} code
 * @returns {console}
 */
export const isPhone = (phone) => {
    const myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
    if (!myreg.test(phone)) {
        return false;
    }
    return true;
}
